function getValueFromQueryFilter(filter, filterKeys) {
  const searchFilter = new URLSearchParams(filter ?? "");
  return searchFilter.get(filterKeys);
}
export {
  getValueFromQueryFilter
};
//# sourceMappingURL=query.js.map
